// import companyName from '../store/mobxStore/companyName';
// const COMPANY_NAME =companyName.companyName??'Company Name';
// const BASE_URL = "http://192.168.7.15/WC/capua/backoffice/api/";
// const IMG_URL = "http://192.168.7.15/WC/capua/backoffice/uploads/images/";
// const BASE = "http://192.168.7.15/WC/capua/backoffice/";
// const API_KEY =localStorage.getItem('apiKey'); //binaryaddon;
// const DEFAULT_KEY ='30ea12d6-8a12-4a1d-baa9-1d28625c5e07'
// export {
//     COMPANY_NAME,
//     BASE_URL,
//     IMG_URL,
//     API_KEY,
//     BASE,
//     DEFAULT_KEY
// }


// import companyName from '../store/mobxStore/companyName';
// const COMPANY_NAME =companyName.companyName??'Company Name';
// const BASE_URL = "http://demo8.infinitemlmdemo.com/rodnelio/backoffice/api/";
// const IMG_URL = "http://demo8.infinitemlmdemo.com/rodnelio/uploads/images/";
// const BASE = "http://demo8.infinitemlmdemo.com/rodnelio/";
// const API_KEY =localStorage.getItem('apiKey'); //binaryaddon;
// const DEFAULT_KEY ='30ea12d6-8a12-4a1d-baa9-1d28625c5e07'
// export {
//     COMPANY_NAME,
//     BASE_URL,
//     IMG_URL,
//     API_KEY,
//     BASE,
//     DEFAULT_KEY
// }

//live---
import companyName from '../store/mobxStore/companyName';
const COMPANY_NAME =companyName.companyName??'Company Name';
const BASE_URL = "https://admin.friendshipdiamondextreme.com/backoffice/api/";
const IMG_URL = "https://admin.friendshipdiamondextreme.com/uploads/images/";
const BASE = "https://admin.friendshipdiamondextreme.com/";
const API_KEY =localStorage.getItem('apiKey'); //binaryaddon;
const DEFAULT_KEY ='30ea12d6-8a12-4a1d-baa9-1d28625c5e07'
export {
    COMPANY_NAME,
    BASE_URL,
    IMG_URL,
    API_KEY,
    BASE,
    DEFAULT_KEY
}

//demo new
// import companyName from '../store/mobxStore/companyName';
// const COMPANY_NAME =companyName.companyName??'Company Name';
// const BASE_URL = "http://testadmin.friendshipdiamondextreme.com/api/";
// const IMG_URL = "http://testadmin.friendshipdiamondextreme.com/uploads/images/";
// const BASE = "http://testadmin.friendshipdiamondextreme.com/";
// const API_KEY =localStorage.getItem('apiKey'); //binaryaddon;
// const DEFAULT_KEY ='30ea12d6-8a12-4a1d-baa9-1d28625c5e07'
// export {
//     COMPANY_NAME,
//     BASE_URL,
//     IMG_URL,
//     API_KEY,
//     BASE,
//     DEFAULT_KEY
// }
